import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { noDataFilter, numberFilter } from "app/filters/ngFilters";
import { RightAlignCell } from "./WaKeywordPosition";

export const SERPPositionCell: FC<ITableCellProps> = ({ row: { currentPosition } }) => {
    if (currentPosition === "NaN") {
        return null;
    }
    return (
        <RightAlignCell className="cell-innerText">
            {currentPosition === -1 || currentPosition === null
                ? "-"
                : noDataFilter()(numberFilter()(currentPosition, 0), "^$", "-")}
        </RightAlignCell>
    );
};
SERPPositionCell.displayName = "SERPPositionCell";
